import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import styled from "@emotion/styled"
import Media from "react-media"
import BigPanelBgImgPC from "../images/bigpanel-bg-pc.jpg"
import BigPanelBgImgSP from "../images/bigpanel-bg-sp.jpg"
import WwdLogoImage from "./wwd-logo-image"
import { isAndroid, isIOS } from "react-device-detect"
import facepaint from "facepaint"

const breakpoints = [576, 768, 992, 1200]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))
const BigPanel = () => {
  const SCALE_MIN = 1
  const SCALE_MAX = 100
  const [fixed, setFixed] = useState(true)
  const Container = styled.div`
    box-sizing: border-box;
    width: 100vw;
    height: calc(1vh * 525);

    ::after {
      content: "";
      background-image: url(${BigPanelBgImgSP});
      @media (min-width: 420px) {
        background-image: url(${BigPanelBgImgPC});
      }
      background-attachment: ${isAndroid || isIOS ? "scroll" : "fixed"};
      background-size: cover;
      background-position: center;
      -webkit-transition: all 0.5s;
      -moz-transition: all 0.5s;
      -ms-transition: all 0.5s;
      -o-transition: all 0.5s;
      transition: all 0.5s;
      opacity: ${fixed ? "0.2" : "0"};
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: fixed;
      z-index: -1;
    }
  `
  const NextLeadersLogoContainer = styled.div`
    position: ${fixed ? "fixed" : "static"};
    top: 0;
    left: 0;
    z-index: 3;
    width: 100vw;
    height: calc(1vh * 100);
    display: flex;
    flex-direction: column; /* 子要素をflexboxにより縦方向に揃える */
    justify-content: center; /* 子要素をflexboxにより中央に配置する */
    align-items: center; /* 子要素をflexboxにより中央に配置する */
    overflow: hidden;
  `
  const HeaderTextContainer = styled.div`
    position: ${fixed ? "fixed" : "static"};
    top: 0;
    left: 0;
    z-index: 2;
    width: 100vw;
    height: calc(1vh * 100);
    display: flex;
    flex-direction: column; /* 子要素をflexboxにより縦方向に揃える */
    justify-content: center; /* 子要素をflexboxにより中央に配置する */
    align-items: center; /* 子要素をflexboxにより中央に配置する */
    overflow: hidden;
    opacity: 0;
    font-size: 2rem;
    color: #ffffff;
  `

  const HeaderText = styled.svg`
    width: 70vw;
  `

  const TextContainer = styled.div`
    position: ${fixed ? "fixed" : "static"};
    top: 0;
    left: 0;
    z-index: 3;
    width: 100vw;
    height: calc(1vh * 100);
    display: flex;
    flex-direction: column; /* 子要素をflexboxにより縦方向に揃える */
    justify-content: center; /* 子要素をflexboxにより中央に配置する */
    align-items: center; /* 子要素をflexboxにより中央に配置する */
    overflow: hidden;
    opacity: 0;
    // 13px
    font-size: 0.8125rem;
    line-height: 2;
    text-align: center;

    color: #ffffff;
    p {
      text-align: justify;
      text-justify: inter-ideograph;
      max-width: 590px;
      ${mq({
        width: ["82.0vw", "82.0vw", "56.0vw", "56.0vw"],
        fontSize: ["3.25vw", "1.0rem", "1.0rem", "1.0rem"],
      })}
    }
  `

  const WWDLogo = styled.div`
    position: ${fixed ? "fixed" : "static"};
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    font-weight: bold;
    text-align: center;
    padding-top: 60px;
    transition: 0.7s;
  `
  const NextLeadersLogo = styled.svg`
    width: 100vw;
    height: 100vh;
  `

  const ScrollIconWrapper = styled.div`
    position: ${fixed ? "fixed" : "static"};
    bottom: 30px;
    z-index: 100;
    width: 100%;
    text-align: center;
  `

  const ScrollIcon = styled.div`
    position: relative;
    display: inline-block;
    // 21px
    font-size: 1.3125rem;
    font-weight: bold;
    &:before {
      content: "";
      position: absolute;
      top: -46px;
      left: 0;
      right: 0;
      width: 2px;
      height: 40px;
      margin: 0 auto;
      display: inline-block;
      background-color: #000;
    }
  `

  const DebugToolber = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
    font-size: 1rem;
    text-align: right;
    background-color: aqua;
    width: 100vw;
  `

  const [offset, setOffset] = useState(0)
  const getScrollTop = () => {
    return (
      window.pageYOffset ||
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop
    )
  }

  const [scale, setScale] = useState(0)
  const nextLeadersLogoAnime = offset => {
    let newScale = 1
    newScale = 100 * (offset / window.innerHeight)
    newScale = Math.min(SCALE_MAX, newScale)
    // newScale = Math.floor(newScale)
    // console.log(newScale)

    if (newScale <= SCALE_MIN) {
      newScale = SCALE_MIN
    }
    if (scale !== newScale) {
      setScale(newScale)
    }
  }

  const [headerTextOpacity, setHeaderTextOpacity] = useState(0)
  const headerTextAnime = offset => {
    let opacity = 0

    if (offset < window.innerHeight * 1) {
      opacity = offset / window.innerHeight
      setHeaderTextOpacity(opacity)
    } else if (offset < window.innerHeight * 2) {
      opacity = 2 - offset / window.innerHeight
      setHeaderTextOpacity(opacity)
    } else if (offset < window.innerHeight * 3) {
      opacity = 0
      setHeaderTextOpacity(opacity)
    }
  }

  const textAnime = offset => {
    let opacity = 0

    if (offset < window.innerHeight * 1) {
      opacity = 0
      setTextOpacity(opacity)
    } else if (offset < window.innerHeight * 2) {
      opacity = 0
      setTextOpacity(opacity)
    } else if (offset < window.innerHeight * 2.5) {
      opacity = 2.0 - offset / window.innerHeight
      setTextOpacity(opacity)
    } else if (offset < window.innerHeight * 3) {
      opacity = 1
      setTextOpacity(opacity)
    } else if (offset < window.innerHeight * 4.5) {
      opacity = 4.5 - offset / window.innerHeight
      setTextOpacity(opacity)
    } else if (offset < window.innerHeight * 5) {
      opacity = 0
      setTextOpacity(opacity)
    }
  }

  const [textOpacity, setTextOpacity] = useState(0)

  const onScroll = () => {
    const offset = getScrollTop()
    setOffset(offset)
    nextLeadersLogoAnime(offset)
    headerTextAnime(offset)
    textAnime(offset)

    if (offset >= window.innerHeight * 5.0) {
      setFixed(false)
    } else {
      setFixed(true)
    }
  }

  useEffect(() => {
    setOffset(0)
    setScale(SCALE_MIN)
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
  }, [])

  return (
    <Container>
      <DebugToolber>
        {/*{scale + `:` + offset + `:` + window.innerHeight}*/}
      </DebugToolber>
      <NextLeadersLogoContainer>
        <WWDLogo>
          <WwdLogoImage></WwdLogoImage>
        </WWDLogo>
        <Media
          queries={{
            sp: "(max-width: 767px)",
            pc: "(min-width: 768px)",
          }}
        >
          {matches => (
            <div>
              {matches.sp && (
                <NextLeadersLogo
                  viewBox="0 0 751 1624"
                  version="1.1"
                  css={{
                    transform: `scale(${scale})`,
                    transformOrigin: `53% 50%`,
                  }}
                  preserveAspectRatio="xMidYMid slice"
                >
                  <title>NEXT LEADERS 2020</title>
                  <g id="Page-1" stroke="none" fill="none">
                    <g id="SP">
                      <path
                        d="M751,0 L751,1624 L0,1624 L0,0 L751,0 Z M646.408125,770.998604 C621.950125,770.998604 602.868125,776.253583 602.868125,795.698051 C602.868125,806.208009 608.877625,814.615626 623.425375,816.822647 L623.425375,816.822647 L657.371875,821.868264 C661.377625,822.498094 662.749625,824.705115 662.749625,826.912136 C662.749625,830.486987 660.217375,833.008051 650.942375,833.008051 C646.303125,833.008051 643.034125,832.482902 640.820375,831.432604 C638.711625,830.275881 637.763125,828.594009 637.658125,826.0712 L637.658125,826.0712 L601.812875,826.0712 C601.919625,848.143157 626.904375,851.295796 649.782125,851.295796 C683.200125,851.295796 698.171375,842.678817 698.171375,824.389328 C698.171375,811.672349 688.892875,804.735498 673.923375,802.528477 L673.923375,802.528477 L638.396625,797.273498 C635.444375,796.85303 634.495875,795.486945 634.495875,793.384604 C634.495875,790.231966 637.553125,788.024945 646.408125,788.024945 C649.677125,788.024945 653.051125,788.445413 655.686625,789.600391 C658.427125,790.652434 660.217375,792.543668 660.217375,795.59337 L660.217375,795.59337 L694.797375,795.59337 C693.743875,779.722009 679.932875,770.998604 646.408125,770.998604 Z M81.8076373,774 L52,774 L52,849 L128,849 L128,828.831098 L81.8076373,828.831098 L81.8076373,774 Z M214,774 L134,774 L134,849 L214,849 L214,830.722967 L163.722684,830.722967 L163.722684,820.639388 L210.416761,820.639388 L210.416761,802.362356 L163.722684,802.362356 L163.722684,792.277033 L214,792.277033 L214,774 Z M283.814828,774 L247.185172,774 L215,849 L246.761636,849 L249.937273,840.387869 L281.062727,840.387869 L284.240121,849 L316,849 L283.814828,774 Z M377.947347,774 L320,774 L320,849 L378.579856,849 C403.596402,849 417,837.864994 417,811.499128 C417,783.87434 403.489523,774 377.947347,774 L377.947347,774 Z M501,774 L421,774 L421,849 L501,849 L501,830.722967 L450.722684,830.722967 L450.722684,820.639388 L497.416761,820.639388 L497.416761,802.362356 L450.722684,802.362356 L450.722684,792.277033 L501,792.277033 L501,774 Z M569.919005,774 L507,774 L507,849 L536.869999,849 L536.869999,825.891289 L558.055755,825.891289 C563.564509,825.891289 565.470506,829.251319 565.787,834.818822 C566.316248,843.537117 566.316248,846.794271 567.376503,849 L567.376503,849 L600,849 C598.094003,846.687908 596.611756,843.537117 596.293504,840.175342 L596.293504,840.175342 L595.022253,823.79018 C594.491246,817.277614 590.892006,813.495618 586.441749,812.234952 L586.441749,812.234952 L586.441749,812.025713 C595.127751,809.504382 598.094003,801.94039 598.094003,794.902983 C598.094003,786.711273 593.43275,779.462883 587.820256,776.73057 C583.688252,774.735824 578.49775,774 569.919005,774 L569.919005,774 Z M366.865287,792.908237 C380.479137,792.908237 385.96848,799.630042 385.96848,811.499128 C385.96848,823.369958 380.479137,830.091763 366.865287,830.091763 L366.865287,830.091763 L349.764748,830.091763 L349.764748,792.908237 Z M265.606323,796.689017 L274.500566,822.110411 L256.501192,822.110411 L265.395434,796.689017 L265.606323,796.689017 Z M557.632005,792.908237 C562.609752,792.908237 566.316248,794.273522 566.316248,799.945644 C566.316248,804.672704 563.881003,806.983052 558.055755,806.983052 L558.055755,806.983052 L536.869999,806.983052 L536.869999,792.908237 Z M85.991182,692 L52,692 L52,767 L80.5029676,767 L80.5029676,724.982075 L80.7114917,724.982075 L112.382624,767 L145,767 L145,692 L116.498785,692 L116.498785,733.59595 L116.181618,733.59595 L85.991182,692 Z M233,692 L153,692 L153,767 L233,767 L233,748.722543 L182.722684,748.722543 L182.722684,738.638729 L229.416761,738.638729 L229.416761,720.363015 L182.722684,720.363015 L182.722684,710.277457 L233,710.277457 L233,692 Z M273.243139,692 L238.418564,692 L267.773201,727.819074 L234,767 L270.614705,767 L284.500873,747.671092 L298.388788,767 L335,767 L301.230292,727.819074 L330.581436,692 L295.758607,692 L284.500873,708.387287 L273.243139,692 Z M419,692 L334,692 L334,710.906933 L361.595078,710.906933 L361.595078,767 L391.408432,767 L391.408432,710.906933 L419,710.906933 L419,692 Z"
                        id="Combined-Shape"
                        fill="#FFFFFF"
                      ></path>
                      <g
                        id="2020"
                        transform="translate(309.000000, 855.000000)"
                        fill="#C7A542"
                      >
                        <path
                          d="M57.3680454,29.916418 C61.0515104,29.1785181 63.0522539,27.2830598 63.0522539,24.2282943 C63.0522539,20.0142218 57.8957524,18.3285927 51.0530347,18.3285927 C43.0535552,18.3285927 34.9474858,19.0664926 34.1052514,28.5472815 L2.52495585,28.5472815 C4.7371317,3.36950947 28.8421601,0 47.4744121,0 C71.4728506,0 94,4.21407255 94,24.647953 C94,38.5526438 79.6837624,44.1376014 69.1575797,46.1379744 L42.7372804,51.0881983 C36.4205224,52.2475054 33.0515847,53.9313858 31.2640208,56.6714073 L92.4203736,56.6714073 L92.4203736,75 L0,75 C0.525959662,46.8741257 18.3142299,38.3428145 35.7879729,34.5501492 L57.3680454,29.916418 Z"
                          id="Fill-17"
                        ></path>
                        <path
                          d="M147.139811,58.0251 C160.283084,58.0251 165.540393,48.11485 165.224465,38.7331 C165.224465,28.92785 159.968902,19.0176 146.823884,19.0176 C133.996538,19.0176 128.632756,28.92785 128.632756,38.7331 C128.948684,48.11485 134.31072,58.0251 147.139811,58.0251 M147.139811,0.0406 C177.842356,0.0406 193.931956,13.9566 193.616029,38.7331 C193.616029,63.0861 177.526429,77.00035 146.823884,77.00035 C116.330793,77.00035 100.242938,63.0861 100.242938,38.7331 C100.558865,13.9566 116.644975,0.0406 147.139811,0.0406"
                          id="Fill-19"
                        ></path>
                        <path
                          d="M254.366979,29.916418 C258.050375,29.1785181 260.051082,27.2830598 260.051082,24.2282943 C260.051082,20.0142218 254.894676,18.3285927 248.052086,18.3285927 C240.052755,18.3285927 231.946836,19.0664926 231.104617,28.5472815 L199.524909,28.5472815 C201.737044,3.36950947 225.841624,0 244.47353,0 C268.471522,0 291,4.21407255 291,24.647953 C291,38.5526438 276.682281,44.1376014 266.156294,46.1379744 L239.736486,51.0881983 C233.421593,52.2475054 230.052718,53.9313858 228.26344,56.6714073 L289.420403,56.6714073 L289.420403,75 L197,75 C197.52595,46.8741257 215.31389,38.3428145 232.787308,34.5501492 L254.366979,29.916418 Z"
                          id="Fill-22"
                        ></path>
                        <path
                          d="M342.317917,58.0251 C355.565139,58.0251 360.864028,48.11485 360.545602,38.7331 C360.545602,28.92785 355.248472,19.0176 341.999491,19.0176 C329.070694,19.0176 323.664491,28.92785 323.664491,38.7331 C323.982917,48.11485 329.387361,58.0251 342.317917,58.0251 M342.317917,0.0406 C373.263287,0.0406 389.480139,13.9566 389.161713,38.7331 C389.161713,63.0861 372.944861,77.00035 341.999491,77.00035 C311.265231,77.00035 295.050139,63.0861 295.050139,38.7331 C295.368565,13.9566 311.581898,0.0406 342.317917,0.0406"
                          id="Fill-24"
                        ></path>
                      </g>
                    </g>
                  </g>
                </NextLeadersLogo>
              )}
              {matches.pc && (
                <NextLeadersLogo
                  viewBox="0 0 999 1201"
                  version="1.1"
                  css={{
                    transform: `scale(${scale})`,
                    transformOrigin: `52% 50%`,
                  }}
                  preserveAspectRatio="xMidYMid slice"
                >
                  <title>NEXT LEADERS 2020</title>

                  <g id="Page-1" stroke="none" fill="none">
                    <g id="PC">
                      <path
                        d="M999,0 L999,1201 L0,1201 L0,0 L999,0 Z M721.531205,566.998845 C701.31592,566.998845 685.544062,571.345556 685.544062,587.429252 C685.544062,596.122674 690.511098,603.077122 702.535259,604.902683 L702.535259,604.902683 L730.59308,609.076218 C733.903955,609.597189 735.037955,611.422749 735.037955,613.24831 C735.037955,616.205286 732.944973,618.29061 725.278902,618.29061 C721.44442,618.29061 718.742491,617.856228 716.912759,616.987463 C715.169813,616.030667 714.385848,614.639489 714.299062,612.552721 L714.299062,612.552721 L684.671866,612.552721 C684.760098,630.809772 705.410759,633.41751 724.31992,633.41751 C751.94092,633.41751 764.315116,626.289886 764.315116,611.161543 C764.315116,600.64256 756.646152,594.904671 744.273402,593.07911 L744.273402,593.07911 L714.909455,588.732399 C712.46933,588.384605 711.685366,587.254633 711.685366,585.51566 C711.685366,582.907922 714.212277,581.082362 721.531205,581.082362 C724.233134,581.082362 727.021848,581.430156 729.20017,582.385509 C731.465277,583.255717 732.944973,584.820071 732.944973,587.342664 L732.944973,587.342664 L761.526402,587.342664 C760.655652,574.214501 749.240438,566.998845 721.531205,566.998845 Z M257.316757,569 L233,569 L233,631 L295,631 L295,614.327041 L257.316757,614.327041 L257.316757,569 Z M366,569 L300,569 L300,631 L366,631 L366,615.890986 L324.521214,615.890986 L324.521214,607.555227 L363.043828,607.555227 L363.043828,592.446214 L324.521214,592.446214 L324.521214,584.109014 L366,584.109014 L366,569 Z M423.5508,569 L393.4492,569 L367,631 L393.101147,631 L395.710828,623.880638 L421.289172,623.880638 L423.900298,631 L450,631 L423.5508,569 Z M500.791626,569 L453,569 L453,631 L501.313283,631 C521.945486,631 533,621.795062 533,599.999279 C533,577.162788 521.857339,569 500.791626,569 L500.791626,569 Z M602,569 L536,569 L536,631 L602,631 L602,615.890986 L560.521214,615.890986 L560.521214,607.555227 L599.043828,607.555227 L599.043828,592.446214 L560.521214,592.446214 L560.521214,584.109014 L602,584.109014 L602,569 Z M658.417681,569 L607,569 L607,631 L631.409892,631 L631.409892,611.896799 L648.722983,611.896799 C653.22476,611.896799 654.782349,614.674424 655.040989,619.276893 C655.473493,626.484016 655.473493,629.176598 656.339938,631 L656.339938,631 L683,631 C681.442411,629.088671 680.231112,626.484016 679.971035,623.70495 L679.971035,623.70495 L678.932164,610.159882 C678.498223,604.776161 675.556908,601.649711 671.920139,600.607561 L671.920139,600.607561 L671.920139,600.43459 C679.018377,598.350289 681.442411,592.097389 681.442411,586.279799 C681.442411,579.507986 677.633215,573.515984 673.046661,571.257271 C669.669969,569.608281 665.428269,569 658.417681,569 L658.417681,569 Z M491.651783,584.630809 C502.879701,584.630809 507.406994,590.187501 507.406994,599.999279 C507.406994,609.812499 502.879701,615.369191 491.651783,615.369191 L491.651783,615.369191 L477.548246,615.369191 L477.548246,584.630809 Z M408.587375,587.756254 L415.896504,608.771273 L401.10494,608.771273 L408.41407,587.756254 L408.587375,587.756254 Z M648.376692,584.630809 C652.444528,584.630809 655.473493,585.759445 655.473493,590.448399 C655.473493,594.356102 653.4834,596.265989 648.722983,596.265989 L648.722983,596.265989 L631.409892,596.265989 L631.409892,584.630809 Z M260.77774,502 L233,502 L233,564 L256.292748,564 L256.292748,529.265182 L256.463155,529.265182 L282.34494,564 L309,564 L309,502 L285.708684,502 L285.708684,536.385985 L285.449494,536.385985 L260.77774,502 Z M382,502 L316,502 L316,564 L382,564 L382,548.890635 L340.521214,548.890635 L340.521214,540.554682 L379.043828,540.554682 L379.043828,525.446759 L340.521214,525.446759 L340.521214,517.109365 L382,517.109365 L382,502 Z M415.249313,502 L386.631098,502 L410.754215,531.610434 L383,564 L413.089312,564 L424.500718,548.021436 L435.913558,564 L466,564 L438.248656,531.610434 L462.368902,502 L433.752123,502 L424.500718,515.546824 L415.249313,502 Z M535,502 L465,502 L465,517.629731 L487.725358,517.629731 L487.725358,564 L512.277532,564 L512.277532,517.629731 L535,517.629731 L535,502 Z"
                        id="next"
                        fill="#FFFFFF"
                      ></path>
                      <g
                        id="2020"
                        transform="translate(444.000000, 636.000000)"
                        fill="#C7A542"
                      >
                        <path
                          d="M281.8505,47.6103385 C292.727167,47.6103385 297.077833,39.4788513 296.816389,31.7810051 C296.816389,23.7356718 292.467167,15.6041846 281.589056,15.6041846 C270.973833,15.6041846 266.535056,23.7356718 266.535056,31.7810051 C266.7965,39.4788513 271.233833,47.6103385 281.8505,47.6103385 M281.8505,0.0333128205 C307.258278,0.0333128205 320.573167,11.4515692 320.311722,31.7810051 C320.311722,51.7629538 306.996833,63.1797744 281.589056,63.1797744 C256.354611,63.1797744 243.041167,51.7629538 243.041167,31.7810051 C243.302611,11.4515692 256.614611,0.0333128205 281.8505,0.0333128205"
                          id="Fill-24"
                        ></path>
                        <path
                          d="M46.9929733,24.7309055 C50.0102798,24.1209083 51.6491867,22.5539961 51.6491867,20.0287233 C51.6491867,16.54509 47.425244,15.1516367 41.820039,15.1516367 C35.2672739,15.1516367 28.6271958,15.7616339 27.9372804,23.5990861 L2.0683149,23.5990861 C3.8804164,2.78546116 23.6260247,0 38.8886142,0 C58.5469096,0 77,3.48363331 77,20.3756411 C77,31.8701856 65.2728692,36.4870838 56.6503578,38.1407255 L35.0081978,42.2329106 C29.8338321,43.1912711 27.0741705,44.5832789 25.6098894,46.8483633 L75.7060507,46.8483633 L75.7060507,62 L0,62 C0.430839297,38.7492773 15.002082,31.6967267 29.3156799,28.5614567 L46.9929733,24.7309055 Z"
                          id="Fill-17"
                        ></path>
                        <path
                          d="M121.614526,47.6103385 C132.380824,47.6103385 136.687343,39.4788513 136.428551,31.7810051 C136.428551,23.7356718 132.123462,15.6041846 121.355734,15.6041846 C110.848228,15.6041846 106.454492,23.7356718 106.454492,31.7810051 C106.713283,39.4788513 111.10559,47.6103385 121.614526,47.6103385 M121.614526,0.0333128205 C146.764483,0.0333128205 159.944262,11.4515692 159.685471,31.7810051 C159.685471,51.7629538 146.505692,63.1797744 121.355734,63.1797744 C96.3773515,63.1797744 83.1990026,51.7629538 83.1990026,31.7810051 C83.457794,11.4515692 96.6347132,0.0333128205 121.614526,0.0333128205"
                          id="Fill-19"
                        ></path>
                        <path
                          d="M208.9921,24.7309055 C212.00935,24.1209083 213.648227,22.5539961 213.648227,20.0287233 C213.648227,16.54509 209.424362,15.1516367 203.819262,15.1516367 C197.266618,15.1516367 190.626664,15.7616339 189.936761,23.5990861 L164.068276,23.5990861 C165.880344,2.78546116 185.625586,0 200.887891,0 C220.545821,0 239,3.48363331 239,20.3756411 C239,31.8701856 227.271656,36.4870838 218.649305,38.1407255 L197.007547,42.2329106 C191.834709,43.1912711 189.075099,44.5832789 187.609413,46.8483633 L237.706075,46.8483633 L237.706075,62 L162,62 C162.430831,38.7492773 177.001803,31.6967267 191.315135,28.5614567 L208.9921,24.7309055 Z"
                          id="Fill-22"
                        ></path>
                      </g>
                    </g>
                  </g>
                </NextLeadersLogo>
              )}
            </div>
          )}
        </Media>
        <ScrollIconWrapper>
          <ScrollIcon>scroll</ScrollIcon>
        </ScrollIconWrapper>
      </NextLeadersLogoContainer>
      <HeaderTextContainer
        css={{
          opacity: headerTextOpacity,
        }}
      >
        <Media
          queries={{
            sp: "(max-width: 767px)",
            pc: "(min-width: 768px)",
          }}
        >
          {matches => (
            <div>
              {matches.sp && (
                <HeaderText viewBox="0 0 474 156">
                  <title>ファッション界の未来を担う10組</title>
                  <g fill="#FFFFFF">
                    <path
                      d="M48.3,16c-3.3,8.5-6.7,17.6-14.6,27.1C26.2,52.2,18.2,56.6,13.9,59L6,52.6c12.5-5.9,25.4-15.2,32.9-37.1H0.3V7
		h40.9c0.9,0,1.7-0.6,2.4-1.2l7.2,6.5C49.5,13.6,48.8,14.5,48.3,16z"
                    />
                    <path
                      d="M90.3,42.3L85,37.8c4.9-3.8,8.7-8.6,10.9-12.7H58.9v-6.7h37.3c1.5,0,2.8-0.4,3.9-1.4c2.2,2.5,4.7,5,5.6,5.6
		C102.6,29,96.9,36.7,90.3,42.3z M84.6,28.8c-1.7,16.5-4.6,23.3-15,31.9L62.8,57c11.2-8,14.4-14.7,14.4-30.6l7,0.4
		c0.7,0.1,1.4,0.4,1.4,0.8C85.6,28.1,85.1,28.5,84.6,28.8z"
                    />
                    <path
                      d="M120.7,34.7c-1.2-4.1-3.1-8-5.5-11.7l6.7-2.5c2.5,3.8,4.3,7.6,5.6,11.7L120.7,34.7z M158.4,21.7
		c-0.7,0.4-0.7,0.7-1.4,3.5c-5.4,22.2-20.1,30.7-27,34.8l-5.8-5.1c14.1-7,23.9-16.9,26.7-37.4l7.1,2.2c0.9,0.3,1.4,0.8,1.4,1.3
		C159.3,21.4,159.2,21.5,158.4,21.7z M134,31.2c-1.2-4.3-2.9-8-5.1-11.7l6.4-2.5c2.7,4.3,4.1,8.8,4.9,11.7L134,31.2z"
                    />
                    <path
                      d="M183.1,31.4c-3.4-2.3-7.9-5.1-14.1-7l4.1-7.2c5.4,1.7,10.1,4.1,14.4,7.5L183.1,31.4z M205,44.3
		c-9.9,8.3-18.3,12.5-24.8,15.6c-0.3,0.1-0.4,0.4-0.6,0.8c-0.3,1-0.4,1.3-0.7,1.3c-0.7,0-1.5-1.4-1.8-2l-3.8-7
		c18.3-7.5,31.1-17,43.2-34.7l5.7,7C219.4,29.4,214.6,36.2,205,44.3z M191,14.9c-4.3-3.2-8.9-5.4-14.1-7l4.1-7.2
		c5.5,1.7,10.1,4.1,14.1,7L191,14.9z"
                    />
                    <path d="M263.3,59.5V57H233v-6.2h30.3v-9.6h-29.3v-6.3h29.3v-9.6h-29.8v-6.2h36.8v40.4H263.3z" />
                    <path
                      d="M298.4,20.1c-4.1-3.4-9.1-6.5-14.8-9.1l4.4-6.8c4.8,2.1,10.6,5.2,15.2,9L298.4,20.1z M319.6,39.8
		c-11.4,9.3-18.3,12.3-27.3,16.2c-0.4,1-0.5,2.2-1.1,2.2c-0.4,0-1.1-0.4-1.6-1.4l-5.1-8.7c5.8-1.4,15.3-3.8,26.9-12.5
		c11.1-8.3,18-17.8,21.2-22.2l5,7.2C334.8,24.4,329.2,32,319.6,39.8z"
                    />
                    <path
                      d="M401.5,46.9c-5.4-2-8.4-3.5-12.7-6.2v21.1h-8.3V36.7h2.7c-2.8-2.4-4.9-4.4-8.7-8.8c-2.1,2.5-4.3,5.1-8.8,9
		l4.1,1c0.5,0.1,0.7,0.4,0.7,0.7c0,0.4-0.2,0.7-0.3,0.8c-0.1,0.2-0.9,1-1,1.2c-0.2,0.4-0.4,5.6-0.6,6.7c-1.5,8.6-6.2,12.2-12.8,15.9
		l-6.2-5.9c3.3-1.3,11.5-4.6,11.5-14.2c0-0.1,0-1.4-0.1-2.7c-6.5,4.3-9.7,5.7-12.7,7l-5.9-6.4c10.4-3.2,15.5-6.4,21.7-13.1H350v-27
		h50.2v27h-14.8c2,2.2,4,4.6,9.2,7.4c5.1,2.8,9.1,3.8,12.7,4.7L401.5,46.9z M371,7.1h-13.3v4.1H371V7.1z M371,16.7h-13.3v5.1H371
		V16.7z M392.3,7.1h-12.7v4.1h12.7V7.1z M392.3,16.7h-12.7v5.1h12.7V16.7z"
                    />
                    <path
                      d="M470.6,46.2c-5.4,8-13,11.2-16.9,12.7l-5.4-7.5c3.3-0.9,8.6-2.5,13-7.8c4.4-5.2,5.2-11.2,5.2-14.4
		c0-4-1.2-8.8-5.2-12.7c-4.6-4.3-9.6-4.6-12.3-4.9c-2.3,17.2-6.6,27.4-9,32.2c-2.2,4.5-5.5,10.6-9.3,10.6c-2.6,0-14.5-6.5-14.5-19.5
		c0-16.1,13.3-30.7,31.9-30.7c15.1,0,26.9,10.2,26.9,26.4C475.2,37.2,473.2,42.2,470.6,46.2z M431.6,18.3
		c-5.1,4.9-7.2,11.7-7.2,16.1c0,5.9,3.3,8.9,4.6,8.9c3.8,0,10-18.9,11.4-30.2C438.3,13.9,435.1,14.9,431.6,18.3z"
                    />
                  </g>
                  <g fill="#FFFFFF">
                    <path
                      d="M56.7,152.9c-2-1.3-6.2-4-11-8.8c-5.4-5.4-8.3-9.9-9.8-12.2v23.5h-8.3v-23.3c-4.5,7-11.2,14.5-20.5,20.6
		l-7.6-6.4c11.3-5.1,20.1-15,23.8-21.4H0.5V117h27.1v-7.7H4.9v-8h22.7v-8.8l7.7,0.3c0.5,0,2.2,0.2,2.2,1.1c0,0.4-0.4,0.7-0.7,0.9
		c-0.7,0.6-0.9,0.7-0.9,1.1v5.4h22.9v8H35.9v7.7H63v7.8H40.1c7.2,10.7,13.4,16.2,24,21.3L56.7,152.9z"
                    />
                    <path
                      d="M112.9,129c5.1,8.3,13.2,14,21.9,18.4l-5.9,6.2c-11.4-6.1-16.9-13.6-20.5-18.7V155h-7.8v-21.2
		c-5.1,7.4-11.2,13.8-22,20.4l-6.2-5.9c10-5.4,17.5-11.9,22.6-19.3H73v-7.2h14.6c-1.3-3.1-3.9-9.1-5.7-12l5.6-2.6H76.6v-7h23.9v-7.6
		l7.9,0.9c0.8,0.1,1.3,0.3,1.3,0.8c0,0.4-0.3,0.7-0.7,0.9c-0.5,0.4-0.7,0.7-0.7,0.9v4.1h23.9v7h-12.5l5.3,2.3
		c0.4,0.1,1.2,0.6,1.2,1.2c0,0.2-0.2,0.4-0.5,0.6c-0.8,0.4-0.9,0.4-1,0.7c-1.3,3.2-2,4.6-4.8,9.8h15.5v7.2H112.9z M100.5,107.1H89.2
		c1.4,2,4.3,8.2,5.6,12.1l-4.6,2.5h10.3V107.1z M108.3,107.1v14.6h8.2l-3.7-2.2c2.5-4.2,3.9-8.1,5.4-12.4H108.3z"
                    />
                    <path
                      d="M180.7,128.4c0,2.8,0.1,11.8,0.1,14.3h-8.4c0.2-4.1,0.3-7.7,0.4-10.9c-2.8,1.4-10.3,5.1-10.3,10.2
		c0,4.7,5.6,5.7,10.9,5.7c6.2,0,12.4-0.9,18.5-2.3v8.2c-6.9,1.1-14.9,1.1-17.2,1.1c-4.1,0-12.5,0-17-4.9c-2.8-2.9-2.8-6.1-2.8-7.1
		c0-9,6.7-12.4,17.5-18c-0.4-2.2-1.3-4.8-5.5-4.8c-7.1,0-11.4,6.6-15.4,13.1l-7.1-4.4c5.7-6.2,9.3-11.3,14.3-19.9
		c-4.1,0.2-6.4,0.3-9.4,0.3l-0.9-7.5c4.3,0.4,7.5,0.5,13.8,0.3c1.8-3.9,2.8-6.4,3.6-9.6l9.1,1.6c0.2,0.1,1.4,0.2,1.4,0.7
		c0,0.4-0.3,0.7-0.7,0.8c-0.1,0.1-1.6,0.7-1.7,0.7c-0.1,0.1-1.9,4.1-2.2,4.9c6.7-1.1,9.9-2,14.2-3.7l-0.5,8.1
		c-6.5,1.5-12.5,2.2-17.3,2.8c-2.3,4.3-2.9,5.3-4.1,7.2c0.9-0.4,3.1-1.5,6.2-1.5c5,0,8.2,2.5,9.9,7.3c8.5-4,9.4-4.4,12.8-5.9
		l2.5,8.3C189.5,125.1,186,126.3,180.7,128.4z"
                    />
                    <path
                      d="M221.7,129.5v20.4c0,4.5-4.9,5.3-11,5.4l-4-8.4c1.7,0.1,3.3,0.1,5.6,0.1c1.4,0,1.7-0.4,1.7-2v-12.7
		c-0.9,0.3-5.1,1.7-5.4,1.7c-0.4,0.2-0.7,0.5-0.9,0.9c-1,1.4-1.2,1.6-1.5,1.6c-0.8,0-1.2-0.7-1.4-2.8l-0.9-7.7
		c1.4-0.4,8.5-2,10.1-2.4V112h-9.5v-7.8h9.5V92.4l6.5,0.2c0.9,0,2.6,0.2,2.6,1c0,0.4-0.2,0.8-0.7,1.3c-0.6,0.5-0.7,0.8-0.7,1.2v8
		h7.6v7.8h-7.6v9.3c1.1-0.4,6.5-2.2,7.8-2.5v7.8C227.4,127.4,224.4,128.4,221.7,129.5z M224.9,152.7V145h42.1v7.7H224.9z
		 M255.2,140.4v-1.9h-15.6v1.9h-7.8V93.7h31.4v46.7H255.2z M255.2,101.5h-15.6v10.6h15.6V101.5z M255.2,119.9h-15.6v10.9h15.6V119.9
		z"
                    />
                    <path
                      d="M309.2,143.9c-6.2,7.5-13.9,10.2-18.8,12l-5.6-7c4.3-1.2,12.1-3.5,18.1-10.9c3-3.8,5.3-8.5,5.3-13.8
		c0-6.4-4.3-7.7-6.5-7.7c-6,0-17.7,5.8-23,8.4l-3.3-8.4c5.4-2.1,19.2-7.6,28.5-7.6c1.9,0,6.4,0.4,9.6,4c2.6,2.9,3.1,7.2,3.1,10.3
		C316.6,130.8,314,138.1,309.2,143.9z M306.2,102.6c-4.6-0.1-12.6-0.7-20.1-1.8l-0.7-8.9c8.4,2,13.4,2.4,21.7,2.5L306.2,102.6z"
                    />
                    <path d="M338.6,151.5v-36.8h-14.3v-6.9h4.2c3.8,0,9.9-2.3,11.5-9.2h7.8v52.9H338.6z" />
                    <path
                      d="M382,152.5c-16.8,0-18.4-19.7-18.4-26.5c0-8.7,1.5-28.3,18.4-28.3c6.7,0,11.1,3.3,13.9,7.8
		c3.6,5.8,4.5,12.8,4.5,19.6C400.4,131.7,399.3,152.5,382,152.5z M381.8,105.5c-4.9,0-8.3,3.5-8.3,19.6c-0.1,16.7,3.8,19.6,8.5,19.6
		c5.3,0,8.4-4.1,8.4-19.6C390.4,108.3,386.6,105.5,381.8,105.5z"
                    />
                    <path
                      d="M415.5,133.1c-0.4,7.8-2,13-2.7,15.4l-7.1-1.4c1.9-5,3.1-9.9,3.5-16.9l6.1,0.9c0.7,0.1,1.5,0.4,1.5,0.8
		C416.8,132.4,416.2,132.6,415.5,133.1z M429.8,127.7c-0.1-0.7-0.4-2-0.6-2.5c-1.6,0.3-3.5,0.6-4.8,0.8v29h-7.3V127
		c-1.8,0.3-4.8,0.5-6.6,0.9c-0.2,0-0.5,0.1-0.7,0.4c-0.4,0.4-0.7,0.7-0.9,0.7c-0.3,0-0.5-0.3-0.6-0.6l-1.5-8c2,0.1,2.8,0.1,5.4,0.1
		c1.7-2,3-3.7,4.3-5.6c-3.1-3.1-6.1-5.4-9.6-7.7l4.2-5.9c0.4,0.3,1.1,0.8,2.2,1.7c2.7-4.1,4.2-7.8,5.6-11.7l7.3,3
		c0.4,0.1,0.7,0.4,0.7,0.8c0,0.6-0.6,0.7-0.9,0.8c-1.1,0.1-1.2,0.2-1.9,1.6c-2.2,4-3.5,6.2-5.7,9.5c1.4,1.2,1.5,1.3,2.4,2.2
		c3-4.3,4.6-6.7,6.7-10.6l6.7,4.3c0.4,0.2,0.4,0.6,0.4,0.7c0,0.2-0.1,0.5-0.4,0.7c-0.2,0.1-1.1,0.3-1.2,0.4
		c-0.1,0.1-11,13.5-12.5,15.3c1.8-0.1,3.9-0.1,6.8-0.7c-0.8-2.4-1.2-3.2-1.4-3.8l6.2-2.5c2.4,5.6,3.5,9.9,4.3,12.9L429.8,127.7z
		 M427.8,143.6c-0.7-4.2-1.1-8.3-1.2-12.5l5.7-1.5c0.4,4.1,0.9,7.4,2.2,12.6L427.8,143.6z M431.3,153.9v-7.5h6.9V94.3h27.3v52.2h4.9
		v7.5H431.3z M457.9,101.4h-12.2v9.9h12.2V101.4z M457.9,118.5h-12.2v10.2h12.2V118.5z M457.9,136h-12.2v10.5h12.2V136z"
                    />
                  </g>
                </HeaderText>
              )}
              {matches.pc && (
                <HeaderText viewBox="0 0 985 66">
                  <title>ファッション界の未来を担う10組</title>
                  <g fill="#FFFFFF">
                    <path
                      d="M58.4,18.3c-3.3,8.7-6.9,18-14.9,27.7c-7.6,9.3-15.8,13.8-20.3,16.2l-8.1-6.5c12.8-6,26-15.5,33.6-37.9H9.4
		V9.2h41.8c0.9,0,1.7-0.6,2.4-1.2l7.3,6.7C59.7,15.9,59,16.8,58.4,18.3z"
                    />
                    <path
                      d="M101.3,45.2l-5.4-4.7c5-3.9,8.9-8.8,11.1-13H69.3v-6.9h38.1c1.6,0,2.8-0.4,4-1.5c2.3,2.6,4.8,5.1,5.8,5.7
		C113.9,31.6,108.1,39.5,101.3,45.2z M95.5,31.4C93.8,48.3,90.7,55.2,80.2,64l-6.9-3.8C84.7,52,88,45.1,88,28.8l7.2,0.4
		c0.7,0.1,1.4,0.4,1.4,0.8C96.6,30.7,96,31.1,95.5,31.4z"
                    />
                    <path
                      d="M132.4,37.4c-1.3-4.2-3.2-8.1-5.6-11.9l6.8-2.6c2.5,3.9,4.4,7.8,5.7,11.9L132.4,37.4z M170.9,24.2
		c-0.7,0.4-0.7,0.7-1.5,3.6c-5.6,22.7-20.5,31.4-27.6,35.5l-5.9-5.3c14.4-7.1,24.4-17.2,27.2-38.2l7.3,2.2c1,0.3,1.5,0.8,1.5,1.3
		C171.8,23.8,171.7,23.9,170.9,24.2z M146,33.8c-1.3-4.4-3-8.2-5.3-12l6.6-2.5c2.7,4.4,4.2,9,5,12L146,33.8z"
                    />
                    <path
                      d="M196.2,34c-3.5-2.4-8.1-5.3-14.4-7.2l4.2-7.4c5.6,1.7,10.3,4.1,14.7,7.6L196.2,34z M218.5,47.2
		c-10.1,8.5-18.6,12.7-25.4,16c-0.3,0.1-0.4,0.4-0.6,0.8c-0.3,1-0.4,1.3-0.7,1.3c-0.7,0-1.6-1.4-1.9-2l-3.9-7.1
		c18.6-7.7,31.7-17.4,44.2-35.4l5.8,7.1C233.3,32,228.3,39,218.5,47.2z M204.2,17.2c-4.4-3.3-9.1-5.6-14.4-7.2l4.2-7.4
		c5.6,1.7,10.3,4.1,14.4,7.2L204.2,17.2z"
                    />
                    <path d="M278.1,62.7v-2.6h-30.9v-6.4h30.9V44h-29.9v-6.4h29.9v-9.8h-30.5v-6.4h37.6v41.3H278.1z" />
                    <path
                      d="M313.9,22.5c-4.2-3.5-9.3-6.7-15.2-9.3l4.5-7c4.9,2.1,10.9,5.3,15.5,9.2L313.9,22.5z M335.6,42.6
		c-11.7,9.5-18.7,12.6-27.9,16.5c-0.4,1-0.5,2.3-1.1,2.3c-0.4,0-1.1-0.4-1.6-1.4l-5.2-8.9c5.9-1.4,15.6-3.9,27.5-12.8
		c11.3-8.4,18.4-18.2,21.7-22.6l5.1,7.4C351.1,26.9,345.4,34.7,335.6,42.6z"
                    />
                    <path
                      d="M419.2,49.9c-5.6-2.1-8.6-3.6-13-6.4V65h-8.4V39.4h2.7c-2.8-2.4-5-4.5-8.9-9c-2.1,2.6-4.4,5.2-9,9.2l4.2,1
		c0.5,0.1,0.7,0.4,0.7,0.7c0,0.4-0.2,0.7-0.3,0.8c-0.1,0.2-0.9,1-1,1.3c-0.2,0.4-0.4,5.8-0.6,6.8c-1.6,8.8-6.4,12.5-13.1,16.2
		l-6.3-6c3.4-1.3,11.8-4.7,11.8-14.5c0-0.1,0-1.5-0.1-2.7c-6.7,4.4-9.9,5.8-13,7.1l-6-6.5c10.7-3.3,15.8-6.5,22.1-13.4h-14.5V2.8
		h51.3v27.6h-15.2c2,2.3,4.1,4.7,9.4,7.5c5.2,2.8,9.3,3.8,13,4.8L419.2,49.9z M388.1,9.2h-13.5v4.1h13.5V9.2z M388.1,19h-13.5v5.2
		h13.5V19z M409.9,9.2h-13v4.1h13V9.2z M409.9,19h-13v5.2h13V19z"
                    />
                    <path
                      d="M489.8,49.2c-5.5,8.2-13.2,11.4-17.2,13l-5.5-7.6c3.3-1,8.8-2.5,13.3-7.9c4.5-5.3,5.3-11.5,5.3-14.7
		c0-4.1-1.2-9-5.3-13c-4.7-4.4-9.8-4.7-12.6-5c-2.4,17.6-6.7,28-9.2,32.9c-2.2,4.6-5.6,10.8-9.5,10.8c-2.7,0-14.8-6.7-14.8-19.9
		c0-16.4,13.5-31.4,32.6-31.4c15.4,0,27.5,10.4,27.5,26.9C494.6,39.9,492.6,45.1,489.8,49.2z M450,20.7c-5.3,5-7.4,11.9-7.4,16.4
		c0,6,3.4,9.1,4.7,9.1c3.8,0,10.2-19.3,11.7-30.9C456.9,16.1,453.6,17.2,450,20.7z"
                    />
                    <path
                      d="M561.8,63.2c-2-1.3-6.3-4.1-11.2-9c-5.6-5.5-8.4-10.1-10-12.5v24.1H532V41.9c-4.6,7.1-11.5,14.8-20.9,21
		l-7.8-6.5c11.5-5.2,20.6-15.3,24.3-21.9h-23.3v-8H532v-7.8h-23.2v-8.1H532v-9l7.8,0.3c0.5,0,2.2,0.2,2.2,1.1c0,0.4-0.4,0.7-0.7,1
		c-0.7,0.6-0.9,0.7-0.9,1.1v5.6h23.4v8.1h-23.4v7.8h27.7v8h-23.3c7.3,11,13.7,16.5,24.5,21.8L561.8,63.2z"
                    />
                    <path
                      d="M619.2,38.8c5.3,8.4,13.5,14.3,22.3,18.8l-6.1,6.4c-11.6-6.2-17.3-13.9-20.9-19.1v20.5h-8V43.6
		c-5.3,7.5-11.5,14.1-22.5,20.9l-6.3-6c10.2-5.5,17.9-12.1,23.1-19.8h-22.3v-7.4h14.9c-1.3-3.2-4-9.3-5.8-12.3l5.7-2.7h-11.1V9.2
		h24.4V1.5l8.1,0.9c0.8,0.1,1.3,0.3,1.3,0.8c0,0.4-0.3,0.7-0.7,1c-0.5,0.4-0.7,0.7-0.7,0.9v4.2h24.4v7.2h-12.8l5.4,2.4
		c0.4,0.1,1.3,0.6,1.3,1.3c0,0.2-0.2,0.4-0.5,0.6c-0.8,0.4-0.9,0.4-1,0.7c-1.3,3.3-2,4.7-4.9,10h15.8v7.4H619.2z M606.5,16.4H595
		c1.5,2,4.4,8.4,5.8,12.4l-4.7,2.6h10.5V16.4z M614.5,16.4v14.9h8.4l-3.8-2.3c2.6-4.3,4-8.3,5.5-12.7H614.5z"
                    />
                    <path
                      d="M688.4,38.1c0,2.9,0.1,12.1,0.1,14.6H680c0.2-4.2,0.3-7.8,0.4-11.1c-2.8,1.4-10.5,5.3-10.5,10.4
		c0,4.8,5.7,5.8,11.1,5.8c6.4,0,12.7-1,18.9-2.4v8.4c-7,1.1-15.2,1.1-17.6,1.1c-4.1,0-12.7,0-17.4-5c-2.8-3-2.8-6.2-2.8-7.3
		c0-9.2,6.8-12.7,17.9-18.4c-0.4-2.2-1.3-4.9-5.6-4.9c-7.3,0-11.7,6.7-15.8,13.4l-7.3-4.5c5.8-6.3,9.5-11.5,14.6-20.4
		c-4.2,0.2-6.5,0.3-9.6,0.3l-0.9-7.7c4.4,0.4,7.7,0.5,14.1,0.3c1.9-4,2.8-6.6,3.7-9.8l9.3,1.6c0.2,0.1,1.5,0.2,1.5,0.7
		c0,0.4-0.3,0.7-0.7,0.8c-0.1,0.1-1.6,0.7-1.7,0.7c-0.1,0.1-1.9,4.2-2.3,5c6.8-1.1,10.1-2.1,14.5-3.8l-0.5,8.3
		c-6.7,1.6-12.7,2.2-17.7,2.8c-2.4,4.4-3,5.4-4.2,7.3c1-0.4,3.2-1.6,6.4-1.6c5.1,0,8.4,2.6,10.1,7.5c8.7-4.1,9.6-4.5,13.1-6.1
		l2.5,8.4C697.5,34.8,693.9,36,688.4,38.1z"
                    />
                    <path
                      d="M730.3,39.2V60c0,4.6-5,5.4-11.2,5.5l-4.1-8.6c1.7,0.1,3.3,0.1,5.7,0.1c1.4,0,1.8-0.4,1.8-2v-13
		c-0.9,0.3-5.2,1.7-5.6,1.8c-0.4,0.2-0.7,0.5-1,0.9c-1,1.5-1.2,1.6-1.6,1.6c-0.8,0-1.2-0.7-1.4-2.9l-0.9-7.8
		c1.5-0.4,8.7-2.1,10.4-2.4V21.4h-9.7v-8h9.7v-12l6.7,0.2c0.9,0,2.7,0.2,2.7,1c0,0.4-0.2,0.8-0.7,1.3c-0.6,0.5-0.7,0.8-0.7,1.2v8.2
		h7.8v8h-7.8v9.5c1.1-0.4,6.7-2.2,7.9-2.6v8C736.2,37.1,733.1,38.2,730.3,39.2z M733.6,63v-7.8h43V63H733.6z M764.6,50.4v-1.9h-15.9
		v1.9h-8V2.6h32v47.7H764.6z M764.6,10.6h-15.9v10.9h15.9V10.6z M764.6,29.4h-15.9v11.1h15.9V29.4z"
                    />
                    <path
                      d="M819.7,53.9c-6.3,7.6-14.2,10.4-19.2,12.3l-5.7-7.1c4.4-1.3,12.4-3.6,18.5-11.1c3.1-3.8,5.4-8.7,5.4-14.1
		c0-6.5-4.4-7.8-6.7-7.8c-6.1,0-18.1,5.9-23.5,8.6l-3.4-8.6c5.5-2.1,19.6-7.8,29.1-7.8c1.9,0,6.5,0.4,9.8,4.1
		c2.7,3,3.2,7.4,3.2,10.5C827.3,40.5,824.6,48,819.7,53.9z M816.7,11.8c-4.7-0.1-12.9-0.7-20.5-1.9l-0.7-9.1
		c8.6,2.1,13.7,2.4,22.2,2.6L816.7,11.8z"
                    />
                    <path d="M849.8,61.7V24.1h-14.7v-7h4.3c3.9,0,10.1-2.4,11.8-9.4h8v54H849.8z" />
                    <path
                      d="M894.1,62.7c-17.2,0-18.8-20.1-18.8-27.1c0-8.9,1.6-28.9,18.8-28.9c6.8,0,11.3,3.3,14.2,7.9
		c3.7,5.9,4.6,13.1,4.6,20.1C912.9,41.5,911.8,62.7,894.1,62.7z M893.9,14.7c-5,0-8.5,3.6-8.5,20c-0.1,17.1,3.8,20.1,8.7,20.1
		c5.4,0,8.6-4.1,8.6-20.1C902.7,17.6,898.8,14.7,893.9,14.7z"
                    />
                    <path
                      d="M928.3,42.9c-0.4,7.9-2,13.3-2.7,15.8l-7.3-1.5c1.9-5.1,3.2-10.1,3.6-17.2l6.2,0.9c0.7,0.1,1.6,0.4,1.6,0.8
		C929.7,42.2,929.1,42.5,928.3,42.9z M942.9,37.4c-0.1-0.7-0.4-2-0.6-2.5c-1.6,0.3-3.6,0.6-4.9,0.8v29.7H930V36.7
		c-1.9,0.3-4.9,0.5-6.7,0.9c-0.2,0-0.5,0.1-0.7,0.4c-0.4,0.4-0.7,0.7-1,0.7c-0.3,0-0.5-0.3-0.6-0.6l-1.6-8.1
		c2.1,0.1,2.8,0.1,5.5,0.1c1.7-2,3-3.8,4.4-5.7c-3.2-3.2-6.2-5.6-9.8-7.8l4.3-6.1c0.4,0.3,1.1,0.8,2.3,1.7c2.7-4.1,4.3-7.9,5.7-11.9
		l7.5,3.1c0.4,0.1,0.7,0.4,0.7,0.8c0,0.6-0.6,0.7-0.9,0.8c-1.1,0.1-1.2,0.2-1.9,1.6c-2.3,4.1-3.6,6.4-5.8,9.7
		c1.5,1.3,1.6,1.3,2.4,2.2c3-4.4,4.7-6.8,6.9-10.8l6.8,4.4c0.4,0.2,0.4,0.6,0.4,0.7c0,0.2-0.1,0.5-0.4,0.7c-0.2,0.1-1.1,0.3-1.3,0.4
		c-0.1,0.1-11.2,13.8-12.7,15.6c1.9-0.1,4-0.1,7-0.7c-0.8-2.4-1.2-3.3-1.5-3.9l6.4-2.5c2.4,5.7,3.6,10.1,4.4,13.2L942.9,37.4z
		 M940.9,53.6c-0.7-4.3-1.1-8.5-1.3-12.7l5.8-1.6c0.4,4.1,0.9,7.5,2.2,12.9L940.9,53.6z M944.5,64.2v-7.6h7V3.2h27.9v53.4h5v7.6
		H944.5z M971.6,10.5h-12.5v10.1h12.5V10.5z M971.6,28h-12.5v10.4h12.5V28z M971.6,45.9h-12.5v10.7h12.5V45.9z"
                    />
                  </g>
                </HeaderText>
              )}
            </div>
          )}
        </Media>
      </HeaderTextContainer>
      <TextContainer
        css={{
          opacity: textOpacity,
        }}
      >
        <p>
          令和時代が幕を開けた。新しいファッションビジネスの姿を描くときが来ている。日本全体が変化を求めている今は、ファッション業界としても従来当たり前とされてきた慣習から脱して、新しいゲームを始めるチャンス。いつだって、新しい時代を作るのは新世代だ。「WWDジャパン」は2017年、これからのファッション業界を引っ張っていってくれるであろう“ネクストリーダー”を紹介する企画を立ち上げた。業界内での役割はそれぞれ異なるが、みんな明確なビジョンを持っている。10年後の日本のファッション業界を、いや、もっと広い視野で、ファッションビジネスそのものを引っ張っていってくれる人たちだと期待して、2020年代を切り開く若きリーダー10組を紹介する。
        </p>
      </TextContainer>
    </Container>
  )
}

BigPanel.propTypes = {
  siteTitle: PropTypes.string,
}

BigPanel.defaultProps = {
  siteTitle: ``,
}

export default BigPanel
